import {
    MenuRounded,
    CloseRounded,
    HomeRounded,
    InfoRounded,
    ArticleRounded,
    PeopleRounded,
    CalendarTodayRounded,
    ExpandMoreRounded,
    CookieRounded,
    DashboardRounded,
    DarkModeRounded,
    LightModeRounded,
    FavoriteRounded,
    FavoriteBorderRounded,
    MailRounded,
    ChevronRightRounded,
    PersonRounded,
    NotificationsRounded,
    ChatBubbleRounded,
    SettingsRounded,
    PersonAddRounded,
    AssignmentRounded,
    PublicRounded,
    ExploreRounded,
    LogoutRounded,
    VerifiedUserRounded,
    ArrowForwardRounded,
    LocationOnRounded,
    AccessTimeRounded,
    FilterAltOffRounded,
    WarningRounded,
    UploadRounded,
    CheckRounded,
    RefreshRounded,
    EmojiEventsRounded,
    EmailRounded,
    SubjectRounded,
    SendRounded,
    MonitorHeartRounded,
    TrackChangesRounded,
    TrendingUpRounded,
    CheckCircleRounded,
    SaveRounded,
    VisibilityRounded,
    DescriptionRounded,
    ViewQuiltRounded,
    ImageRounded,
    ShuffleRounded,
    SentimentSatisfiedAltRounded,
    CheckroomRounded,
    StyleRounded,
    CloudUploadRounded,
    DeleteRounded,
    StarRounded,
    StarBorderRounded,
    AddRounded,
    VpnKeyRounded,
    DragIndicatorRounded,
    TextFieldsRounded,
    CloudQueueRounded,
    BarChartRounded,
    InsertPhotoRounded,
    PieChartRounded,
    HighlightOffRounded,
    AutorenewRounded,
    ArrowBackRounded,
    GroupRounded,
    ShieldRounded,
    LockRounded,
    VisibilityOffRounded,
    ErrorRounded,
    SmartphoneRounded,
    PrivacyTipRounded,
    EditRounded,
    SearchRounded,
    SchoolRounded,
    MenuBookRounded,
    ChevronLeftRounded,
    AttachMoneyRounded,
    CardGiftcardRounded,
    ShareRounded,
    HowToRegRounded,
    PersonOffRounded,
    FormatQuoteRounded,
    LinkRounded,
    LinkOffRounded,
    PhotoCameraRounded,
    FormatListBulletedRounded,
    GridViewRounded,
    CropRounded,
    OpenInNewRounded,
    NoteAltRounded,
    RadioButtonUncheckedRounded,
    SpaRounded,
    AutoAwesomeRounded,
    InventoryRounded,
    HistoryRounded,
    RepeatRounded,
    PlayArrowRounded,
    DownloadRounded,
    QrCodeRounded,
    FlagRounded,
    CheckBoxRounded,
    EventRounded,
    NotificationsActiveRounded,
    ScheduleRounded,
    ContentCopyRounded,
    CelebrationRounded,
    Instagram,
    Facebook,
    WhatsApp,
    MoveToInboxRounded,
    MarkEmailReadRounded,
    DeleteSweepRounded
} from '@mui/icons-material';

// Exporting with semantic names to be used across the application
// This centralizes icon selection and ensures consistency (Material Design Rounded)

export const MenuIcon = MenuRounded;
export const CloseIcon = CloseRounded;
export const HomeIcon = HomeRounded;
export const InfoIcon = InfoRounded;
export const BlogIcon = ArticleRounded; // generic article/blog/file icon
export const TeamIcon = PeopleRounded;
export const CalendarIcon = CalendarTodayRounded;
export const ChevronDownIcon = ExpandMoreRounded;
export const ExpandMoreIcon = ExpandMoreRounded;
export const ChevronRightIcon = ChevronRightRounded;
export const CookieIcon = CookieRounded;
export const DashboardIcon = DashboardRounded;
export const DarkModeIcon = DarkModeRounded;
export const LightModeIcon = LightModeRounded;
export const HeartIcon = FavoriteRounded;
export const HeartOutlineIcon = FavoriteBorderRounded;
export const MailIcon = MailRounded;
export const UserIcon = PersonRounded;
export const NotificationIcon = NotificationsRounded;
export const MessageIcon = ChatBubbleRounded;
export const SettingsIcon = SettingsRounded;
export const AddUserIcon = PersonAddRounded;
export const ClipboardIcon = AssignmentRounded; // registrations/clipboard
export const GlobeIcon = PublicRounded;
export const CompassIcon = ExploreRounded;
export const ExploreIcon = ExploreRounded;
export const LogoutIcon = LogoutRounded;
export const VerifiedIcon = VerifiedUserRounded;
export const ArrowRightIcon = ArrowForwardRounded;
export const LocationIcon = LocationOnRounded;
export const TimeIcon = AccessTimeRounded;
export const FilterOffIcon = FilterAltOffRounded;

// Newly added icons
export const AlertIcon = WarningRounded;
export const UploadIcon = UploadRounded;
export const CheckIcon = CheckRounded;
export const RefreshIcon = RefreshRounded;
export const TrophyIcon = EmojiEventsRounded;
export const EmailIcon = EmailRounded;
export const SubjectIcon = SubjectRounded;
export const SendIcon = SendRounded;
export const ActivityIcon = MonitorHeartRounded;
export const TargetIcon = TrackChangesRounded;
export const TrendingUpIcon = TrendingUpRounded;
export const CheckCircleIcon = CheckCircleRounded;

// Batch 2
export const SaveIcon = SaveRounded;
export const EyeIcon = VisibilityRounded;
export const VisibilityIcon = VisibilityRounded;
export const DescriptionIcon = DescriptionRounded;
export const ViewQuiltIcon = ViewQuiltRounded;
export const ImageIcon = ImageRounded;
export const ShuffleIcon = ShuffleRounded;
export const SmileIcon = SentimentSatisfiedAltRounded;
export const ShirtIcon = CheckroomRounded;
export const GlassesIcon = StyleRounded;

// Batch 3
export const CloudUploadIcon = CloudUploadRounded;
export const DeleteIcon = DeleteRounded;
export const StarIcon = StarRounded;
export const StarOutlineIcon = StarBorderRounded;
export const PlusIcon = AddRounded;
export const KeyIcon = VpnKeyRounded;
export const GripIcon = DragIndicatorRounded;
export const TextFieldsIcon = TextFieldsRounded;
export const CloudQueueIcon = CloudQueueRounded;
export const BarChartIcon = BarChartRounded;
export const InsertPhotoIcon = InsertPhotoRounded;
export const PieChartIcon = PieChartRounded;

// Batch 4
export const XCircleIcon = HighlightOffRounded;
export const LoaderIcon = AutorenewRounded;
export const ArrowLeftIcon = ArrowBackRounded;
export const GroupIcon = GroupRounded;
export const GroupsIcon = GroupRounded;
export const ShieldIcon = ShieldRounded;
export const ShieldCheckIcon = VerifiedUserRounded;
export const LockIcon = LockRounded;
export const EyeOffIcon = VisibilityOffRounded;
export const AlertCircleIcon = ErrorRounded;
export const SmartphoneIcon = SmartphoneRounded;
export const ShieldAlertIcon = PrivacyTipRounded;

// Batch 5
export const EditIcon = EditRounded;
export const SearchIcon = SearchRounded;
export const GraduationCapIcon = SchoolRounded;
export const BookOpenIcon = MenuBookRounded;
export const ChevronLeftIcon = ChevronLeftRounded;

// Batch 6
export const DollarIcon = AttachMoneyRounded;
export const GiftIcon = CardGiftcardRounded;
export const ShareIcon = ShareRounded;
export const UserCheckIcon = HowToRegRounded;
export const UserXIcon = PersonOffRounded;

// Batch 7
export const QuoteIcon = FormatQuoteRounded;
export const LinkIcon = LinkRounded;
export const LinkOffIcon = LinkOffRounded;
export const CameraIcon = PhotoCameraRounded;

// Batch 9
export const ListIcon = FormatListBulletedRounded;
export const GridIcon = GridViewRounded;
export const CropIcon = CropRounded;
export const ExternalLinkIcon = OpenInNewRounded;
export const FileEditIcon = NoteAltRounded;
export const CircleIcon = RadioButtonUncheckedRounded;
export const LeafIcon = SpaRounded;
export const SparklesIcon = AutoAwesomeRounded;

// Batch 10 - New Feature Icons
export const InventoryIcon = InventoryRounded;
export const HistoryIcon = HistoryRounded;
export const RepeatIcon = RepeatRounded;
export const PlayIcon = PlayArrowRounded;
export const DownloadIcon = DownloadRounded;
export const QrCodeIcon = QrCodeRounded;
export const FlagIcon = FlagRounded;
export const CheckboxIcon = CheckBoxRounded;
export const EventIcon = EventRounded;
export const NotificationsIcon = NotificationsActiveRounded;
export const ClockIcon = ScheduleRounded;
export const PersonIcon = PersonRounded;
export const AddIcon = AddRounded;
export const CommentIcon = ChatBubbleRounded;
export const ArticleIcon = ArticleRounded;
export const CopyIcon = ContentCopyRounded;
export const CelebrationIcon = CelebrationRounded;
export const InstagramIcon = Instagram;
export const FacebookIcon = Facebook;
export const WhatsAppIcon = WhatsApp;
export const LocationOnIcon = LocationOnRounded;

// Batch 11 - Inbox / Notification Feature
export const InboxIcon = MoveToInboxRounded;
export const MarkReadIcon = MarkEmailReadRounded;
export const DeleteSweepIcon = DeleteSweepRounded;

// Batch 12 - Chat Feature
export const ChatIcon = ChatBubbleRounded;
